import { createTranslations } from '@npco/utils-translations'

export const unlinkContactModalTranslations = createTranslations({
  title: 'Unlink Contact?',
  primaryButtonLabel: 'Unlink Contact',
  modalText:
    'Are you sure you want to unlink this transaction? All historical and future transactions made from this payment method will no longer be linked to this Contact.',
})
